import {createAsyncThunk} from "@reduxjs/toolkit";

import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {setStudents} from "./studentsSlice";




const GetStudents = createAsyncThunk(
    "get/students",
    async (_, { rejectWithValue,dispatch }) => {
        try {
            const response = await request.get("/students");
            dispatch(setStudents(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);





const CreateStudents = createAsyncThunk(
    "create/students",
    async (payload: any, {rejectWithValue}) => {
        try {
            const response = await request.post("/students", payload);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    CreateStudents,
    GetStudents
}